import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Operario/imprimirEtiquetaOperario`, method: 'POST', body: values, token: token})
}
